<template>
  <div class="content-placeholder" :style="styles">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    width: Number,
    height: Number
  },
  computed: {
    styles() {
      const styles = {};
      if (this.width) {
        styles.width = this.width;
      }
      if (this.width) {
        styles.height = this.height;
      }
      return styles;
    }
  }
};
</script>

<style lang="scss" scoped>
.content-placeholder {
  display: inline-flex;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 800px 104px;
  position: relative;
}
@keyframes placeHolderShimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
</style>
